module.exports = __webpack_public_path__ + "img/cupomDesconto.9c6ff5af.svg";